'use strict';

// File generated by bin/sync-static-tables.php
// DO NOT EDIT! (Edit the original in recipe/config/tables/nutrient-groups.php)

import allRecommendations from './recommendations';

const dailyValues = allRecommendations['all-ages'];

export default [
    {
        title: "Macros",
        nutrNos: [
            {nutrNo: '208'}, // Calories
            {nutrNo: '268'}, // Energy
            {nutrNo: '204'}, // Total Fat
            {nutrNo: '606'}, // Saturated Fat
            {nutrNo: '605'}, // Trans Fat
            {nutrNo: '646'}, // Polyunsaturated Fat
            {nutrNo: '645'}, // Monounsaturated Fat
            {nutrNo: '601'}, // Cholesterol
            {nutrNo: '307'}, // Sodium
            {nutrNo: '205'}, // Carbs
            {nutrNo: '209'}, // Starch
            {nutrNo: '291'}, // Fiber
            {nutrNo: 'SFB'}, // Soluble Fiber
            {nutrNo: 'IFB'}, // Insoluble Fiber
            {nutrNo: '269'}, // Sugars, total
            {nutrNo: 'ASG'}, // Added Sugar
            {nutrNo: '203'}, // Protein
            {nutrNo: '257'}, // Adjusted Protein
            {nutrNo: '255'}, // Water
            {nutrNo: '207'}, // Ash
            {nutrNo: 'FLU'}, // Fluids
        ],
    },
    {
        title: "Micro Nutrients",
        nutrNos: [
            {nutrNo: '324', dv: dailyValues['324']}, // Vitamin D
            {nutrNo: '328'}, // Vitamin D (D2 + D3)
            {nutrNo: '325'}, // Vitamin D2
            {nutrNo: '326'}, // Vitamin D3
            {nutrNo: '301', dv: dailyValues['301']}, // Calcium
            {nutrNo: '303', dv: dailyValues['303']}, // Iron
            {nutrNo: '306', dv: dailyValues['306']}, // Potassium
            {nutrNo: '318', dv: dailyValues['318']}, // Vitamin A
            {nutrNo: '320'}, // Vitamin A, RAE
            {nutrNo: '319'}, // Retinol
            {nutrNo: '321'}, // Carotene, beta
            {nutrNo: '322'}, // Carotene, alpha
            {nutrNo: '334'}, // Cryptoxanthin, beta
            {nutrNo: '337'}, // Lycopene
            {nutrNo: '338'}, // Lutein + zeaxanthin
            {nutrNo: '415', dv: dailyValues['415']}, // Vitamin B-6
            {nutrNo: '418', dv: dailyValues['418']}, // Vitamin B-12
            {nutrNo: '578'}, // Vitamin B-12, added
            {nutrNo: '401', dv: dailyValues['401']}, // Vitamin C
            {nutrNo: '323', dv: dailyValues['323']}, // Vitamin E
            {nutrNo: '573'}, // Vitamin E, added
            {nutrNo: '341'}, // Tocopherol, beta
            {nutrNo: '342'}, // Tocopherol, gamma
            {nutrNo: '343'}, // Tocopherol, delta
            {nutrNo: '344'}, // Tocotrienol, alpha
            {nutrNo: '345'}, // Tocotrienol, beta
            {nutrNo: '346'}, // Tocotrienol, gamma
            {nutrNo: '347'}, // Tocotrienol, delta
            {nutrNo: '430', dv: dailyValues['430']}, // Vitamin K
            {nutrNo: '404', dv: dailyValues['404']}, // Thiamin
            {nutrNo: '405', dv: dailyValues['405']}, // Riboflavin
            {nutrNo: '406', dv: dailyValues['406']}, // Niacin
            {nutrNo: '435', dv: dailyValues['435']}, // Folate, DFE
            {nutrNo: '431'}, // Folic acid
            {nutrNo: 'BIO', dv: dailyValues['BIO']}, // Biotin
            {nutrNo: '410', dv: dailyValues['410']}, // Pantothenic acid
            {nutrNo: '305', dv: dailyValues['305']}, // Phosphorus
            {nutrNo: '304', dv: dailyValues['304']}, // Magnesium
            {nutrNo: '309', dv: dailyValues['309']}, // Zinc
            {nutrNo: '317', dv: dailyValues['317']}, // Selenium
            {nutrNo: '315', dv: dailyValues['315']}, // Manganese
            {nutrNo: 'MBD', dv: dailyValues['MBD']}, // Molybdenum
            {nutrNo: 'CHL', dv: dailyValues['CHL']}, // Chloride
            {nutrNo: '421', dv: dailyValues['421']}, // Choline, total
            {nutrNo: '312', dv: dailyValues['312']}, // Copper
            {nutrNo: 'IOD', dv: dailyValues['IOD']}, // Iodine
            {nutrNo: '313'}, // Flouride
            {nutrNo: 'CHR'}, // Chromium
            {nutrNo: 'SUL'}, // Sulfites
        ],
    },
    {
        title: "FODMAPs",
        fodmaps: true,
        nutrNos: [
            {nutrNo: 'OLF'}, // FODMAP Oligos-fructans
            {nutrNo: 'OLG'}, // FODMAP Oligos-GOS
            {nutrNo: 'FRC'}, // FODMAP Fructose
            {nutrNo: 'LAC'}, // FODMAP Lactose
            {nutrNo: 'MAN'}, // FODMAP Mannitol
            {nutrNo: 'SOR'}, // FODMAP Sorbitol
        ],
    },
    {
        title: "Fruits & Vegetable",
        nutrNos: [
            {nutrNo: 'FRU'}, // Fruits
            {nutrNo: 'VEG'}, // Vegetables
            {nutrNo: 'SVG'}, // Starchy Vegetables
            {nutrNo: 'WHG'}, // Whole Grains
            {nutrNo: 'HLF'}, // Healthy Fats
            {nutrNo: 'LPR'}, // Healthy Proteins
            {nutrNo: 'DAI'}, // Dairy
            {nutrNo: 'LFY'}, // Leafy Greens
            {nutrNo: 'BER'}, // Berries
            {nutrNo: 'NUT'}, // Nuts/Seeds
        ],
    },
    {
        title: "Sugars & Alcohols",
        nutrNos: [
            {nutrNo: '221'}, // Alcohol
            {nutrNo: 'SAL'}, // Sugar Alcohol
            {nutrNo: '210'}, // Sucrose
            {nutrNo: '211'}, // Glucose
            {nutrNo: '212'}, // Fructose
            {nutrNo: '214'}, // Maltose
            {nutrNo: '213'}, // Lactose
            {nutrNo: '287'}, // Galactose
        ],
    },
    {
        title: "Stimulants",
        nutrNos: [
            {nutrNo: '262'}, // Caffeine
            {nutrNo: '263'}, // Theobromine
        ],
    },
    {
        title: "Derived Values",
        nutrNos: [
            {nutrNo: 'RAL', disabled: true}, // PRAL
            {nutrNo: 'NTC', disabled: true}, // Net Carbs
        ],
    },
    {
        title: "Omega 3 & 6 Fatty Acids",
        nutrNos: [
            {nutrNo: '619'}, // Alpha-linolenic acid (undiff.)
            {nutrNo: '621'}, // Omega 3 (DHA)
            {nutrNo: '629'}, // Omega 3 (EPA)
            {nutrNo: '631'}, // Omega 3 (DPA)
            {nutrNo: '851'}, // Omega 3 (ALA)
            {nutrNo: '852'}, // Eicosatrienoic acid (20:3 n-3)
            {nutrNo: '618'}, // Linoleic acid (undiff.)
            {nutrNo: '672'}, // Omega 6 (Eicosadienoic acid)
            {nutrNo: '675'}, // Omega 6 (Linoleic acid)
            {nutrNo: '685'}, // Omega 6 (Gamma-linoleic acid)
            {nutrNo: '689'}, // 20:3 undifferentiated
            {nutrNo: '853'}, // Omega 6 (Eicosatrienoic acid)
            {nutrNo: '855'}, // Omega 6 (Eicosatetraenoic acid)
        ],
    },
    {
        title: "Sterols",
        nutrNos: [
            {nutrNo: '636'}, // Phytosterols
            {nutrNo: '638'}, // Stigmasterol
            {nutrNo: '639'}, // Campesterol
            {nutrNo: '641'}, // Beta-sitosterol
        ],
    },
    {
        title: "Other Fatty Acids",
        nutrNos: [
            {nutrNo: '607'}, // Butyric acid
            {nutrNo: '608'}, // Caproic acid
            {nutrNo: '609'}, // Caprylic acid
            {nutrNo: '610'}, // Capric acid
            {nutrNo: '611'}, // Lauric acid
            {nutrNo: '612'}, // Myristic acid
            {nutrNo: '613'}, // Palmitic acid
            {nutrNo: '614'}, // Stearic acid
            {nutrNo: '615'}, // Arachidic acid
            {nutrNo: '617'}, // Oleic acid (undiff.)
            {nutrNo: '620'}, // Arachidonic acid (undiff.)
            {nutrNo: '624'}, // Behenic acid
            {nutrNo: '625'}, // Myristoleic acid
            {nutrNo: '626'}, // Palmitoleic acid
            {nutrNo: '627'}, // Stearidonic acid
            {nutrNo: '628'}, // Eicosenoic acid
            {nutrNo: '630'}, // Erucic acid (undiff.)
            {nutrNo: '652'}, // Pentadecanoic acid (15:0)
            {nutrNo: '653'}, // Margaric acid
            {nutrNo: '654'}, // Lignoceric acid
            {nutrNo: '662'}, // Trans-palmitoleic acid
            {nutrNo: '670'}, // Conjugated Linoleic Acids
            {nutrNo: '671'}, // Nervonic acid
            {nutrNo: '673'}, // Palmitoleic acid
            {nutrNo: '674'}, // Oleic acid
            {nutrNo: '676'}, // Erucic acid
            {nutrNo: '687'}, // Heptadecenoic acid
            {nutrNo: '693'}, // Trans-monoenoic Fat
            {nutrNo: '695'}, // Trans-polyenoic Fat
            {nutrNo: '696'}, // Tridecanoic acid
            {nutrNo: '697'}, // Pentadecenoic acid
        ],
    },
    {
        title: "Amino Acids",
        nutrNos: [
            {nutrNo: '454'}, // Betaine
            {nutrNo: '501'}, // Tryptophan
            {nutrNo: '502'}, // Threonine
            {nutrNo: '503'}, // Isoleucine
            {nutrNo: '504'}, // Leucine
            {nutrNo: '505'}, // Lysine
            {nutrNo: '506'}, // Methionine
            {nutrNo: '507'}, // Cystine
            {nutrNo: '508'}, // Phenylalanine
            {nutrNo: '509'}, // Tyrosine
            {nutrNo: '510'}, // Valine
            {nutrNo: '511'}, // Arginine
            {nutrNo: '512'}, // Histidine
            {nutrNo: '513'}, // Alanine
            {nutrNo: '514'}, // Aspartic acid
            {nutrNo: '515'}, // Glutamic acid
            {nutrNo: '516'}, // Glycine
            {nutrNo: '517'}, // Proline
            {nutrNo: '518'}, // Serine
            {nutrNo: '521'}, // Hydroxyproline
        ],
    },
];
